module.exports = __webpack_public_path__ + "img/star.844d3914.png";